/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {ActivatedRoute, Data} from '@angular/router';

export function lastRouteChild(route: ActivatedRoute): ActivatedRoute {
    if (route.firstChild) {
        return lastRouteChild(route.firstChild);
    }
    return route;
}

export function lastRouteChildData(route: ActivatedRoute): Data {
    return lastRouteChild(route).snapshot.data;
}
